__turbopack_context__.v({
  "className": "avenirnextbold_d7208157-module__9oddTa__className",
  "variable": "avenirnextbold_d7208157-module__9oddTa__variable",
});
